// actions.js

export const FETCH_ORIGINS_REQUEST = "FETCH_ORIGINS_REQUEST";
export const FETCH_ORIGINS_SUCCESS = "FETCH_ORIGINS_SUCCESS";
export const FETCH_ORIGINS_FAILURE = "FETCH_ORIGINS_FAILURE";
export const CREATE_ORIGIN_REQUEST = "CREATE_ORIGIN_REQUEST";
export const CREATE_ORIGIN_SUCCESS = "CREATE_ORIGIN_SUCCESS";
export const CREATE_ORIGIN_FAILURE = "CREATE_ORIGIN_FAILURE";
export const UPDATE_ORIGIN_REQUEST = "UPDATE_ORIGIN_REQUEST";
export const UPDATE_ORIGIN_SUCCESS = "UPDATE_ORIGIN_SUCCESS";
export const UPDATE_ORIGIN_FAILURE = "UPDATE_ORIGIN_FAILURE";

export const fetchOriginsRequest = () => ({
  type: FETCH_ORIGINS_REQUEST,
});

export const fetchOriginsSuccess = (origins) => ({
  type: FETCH_ORIGINS_SUCCESS,
  payload: origins,
});
export const fetchOriginsFailure = (error) => ({
  type: FETCH_ORIGINS_FAILURE,
  payload: error,
});

export const createOriginRequest = () => ({
  type: CREATE_ORIGIN_REQUEST,
});

export const createOriginSuccess = (origins) => ({
  type: CREATE_ORIGIN_SUCCESS,
  payload: origins,
});

export const createOriginFailure = (error) => ({
  type: CREATE_ORIGIN_FAILURE,
  payload: error,
});

export const updateOriginRequest = () => ({
  type: UPDATE_ORIGIN_REQUEST,
});

export const updateOriginSuccess = (origins) => ({
  type: UPDATE_ORIGIN_SUCCESS,
  payload: origins,
});

export const updateOriginFailure = (error) => ({
  type: UPDATE_ORIGIN_FAILURE,
  payload: error,
});
